import { Layout } from 'antd';
import { toArray } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AppHeader from 'src/components/01.layout/header/AppHeader';
import useWindowSize from 'src/hooks/useWindowSize';
import { useGetPosition } from 'src/services/order/get-position';
import { AnnouncementNotificationCard } from 'src/components/announcement-notification';
import MobileMenuDetail from './header/MobileMenuDetail';
import './styles.scss';
import { mobileMenuBreakPoint } from 'src/constants/exchange';
import JoyrideProvider from './JoyrideProvider';
import SupportWidget from '../24.support-button';

const { Content } = Layout;

export const formatDate = 'DD-MM-YYYY HH:mm:ss';

interface ILayoutProps {
  children?: React.ReactNode;
}

export enum ThemesMode {
  dark = 'dark',
  light = 'light',
}

const LayoutDefault: React.FC<ILayoutProps> = ({ children }) => {
  const [isOpenMenuMobile, setIsOpenMenuMobile] = useState(false);
  const [isOpenNotificationMobile, setIsOpenNotificationMobile] = useState(false);
  const userTheme = useSelector((state: any) => state.theme);
  const { isDesktop, width } = useWindowSize();

  const userPositionQuery = useGetPosition({
    select: toArray,
  });

  const handleOpenMenuMobile = (bool: boolean) => {
    setIsOpenMenuMobile(bool);
    setIsOpenNotificationMobile(false);
  };

  useEffect(() => {
    if (width > 1024) setIsOpenMenuMobile(false);
  }, [width]);

  useEffect(() => {
    const body = document.body;
    if (userTheme === 'dark') {
      body.classList.add('dark');
      body.classList.remove('light');
    } else {
      body.classList.add('light');
      body.classList.remove('dark');
    }
  }, [userTheme]);

  return (
    <div id="layout" className="m-0">
      <JoyrideProvider
        setIsOpenMenuMobile={setIsOpenMenuMobile}
        isOpenMenuMobile={isOpenMenuMobile}
      >
        <Layout className="font-poppins min-h-[100vh]">
          <AppHeader
            isOpenMenuMobile={isOpenMenuMobile}
            setIsOpenMenuMobile={handleOpenMenuMobile}
            userPositionData={userPositionQuery.data}
          />
          <Layout className={`site-layout ${userTheme}  `}>
            <Content className="site-layout-background  overflow-y-hidden">
              <div
                className={width <= mobileMenuBreakPoint && isOpenMenuMobile ? '' : 'display-none'}
              >
                <MobileMenuDetail
                  address={''}
                  onClickItem={() => setIsOpenMenuMobile(false)}
                  isOpen={width <= mobileMenuBreakPoint && isOpenMenuMobile}
                  userPositionData={userPositionQuery.data}
                />
              </div>

              <div
                className={
                  isDesktop || (!isOpenMenuMobile && !isOpenNotificationMobile)
                    ? ''
                    : 'display-none'
                }
              >
                {children}
              </div>
            </Content>
            <SupportWidget />
          </Layout>
        </Layout>
      </JoyrideProvider>

      {/* Announcement Notification Card - Fixed positioned on all pages */}
      <AnnouncementNotificationCard />
    </div>
  );
};

export default LayoutDefault;
